import IdlePoint from '@/models/IdlePoint'

export class IdlePointTransformer {
    transform (data) {
        return new IdlePoint(
            data.start,
            data.end,
            data.lat,
            data.lon,
            data.addressLabel,
            data.type
        )
    }
}
